import React from 'react';
import ReactDOM from 'react-dom';
import Zotero from './Zotero';
import * as serviceWorker from './serviceWorker';

var containers = document.getElementsByClassName('zotero-react');
var availableSorts = ["dateAdded", "dateModified", "title", "creator", "itemType", "date", "publisher", "publicationTitle", "journalAbbreviation", "language", "accessDate", "libraryCatalog", "callNumber", "rights", "addedBy", "numItems"];
Array.prototype.forEach.call(containers, function (container, index, array) {
  if (container !== null) {
    var group = container.getAttribute('group');
    var limit = container.getAttribute('limit');
    var start = container.getAttribute('start');
    var pagination = container.getAttribute('pagination');
    var loading = container.getAttribute('loading');
    var search = container.getAttribute('search');
    var itemType = container.getAttribute('itemType');
    var q = container.getAttribute('q');
    var itemQ = container.getAttribute('itemQ');
    var tag = container.getAttribute('tag');
    var qmode = container.getAttribute('qmode');
    var itemQMode = container.getAttribute('itemQMode');
    var itemTag = container.getAttribute('itemTag');
    var sort = container.getAttribute('sort');
    var direction = container.getAttribute('direction');
    var scrollAfterLoad = container.getAttribute('scrollAfterLoad');
    
    if (sort === "" || sort === null) {
      sort = "dateModified";
    }
    
    if (availableSorts.indexOf(sort) < 0) {
      sort = "dateModified";
    }
    
    ReactDOM.render(
      <Zotero
        index={index}
        loading={(loading === null || loading === "" ? true : (loading === 'true' || loading === '1' ? true : false))}
        group={group}
        limit={limit}
        start={start}
        pagination={(pagination === null || pagination === "" ? true : (pagination === 'true' || pagination === '1' ? true : false))}
        search={(search === null || search === "" ? true : (search === 'true' || search === '1' ? true : false))}
        itemType={(itemType === "" ? null : itemType)}
        q={(q === "" ? null : q)}
        itemQ={(itemQ === "" ? null : itemQ)}
        tag={(tag === "" ? null : tag)}
        qmode={(qmode === "" || qmode === null ? "titleCreatorYear" : (qmode === "everything" ? qmode : "titleCreatorYear"))}
        itemQMode={(itemQMode === "" || itemQMode === null ? "contains" : (itemQMode === "startsWith" ? itemQMode : "contains"))}
        itemTag={(itemTag === "" ? null : itemTag)}
        sort={sort}
        direction={(direction === "" || (direction !== 'asc' && direction !== 'desc') ? null : direction)}
        scrollAfterLoad={(scrollAfterLoad === null || scrollAfterLoad === "" ? true : (scrollAfterLoad === 'true' || scrollAfterLoad === '1' ? true : false))}
      />,
      container
    );
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
